export default "__VITE_ASSET__MCPXUPyx__"